import React from "react";
import PropTypes from "prop-types";
import { Page, View, Image, Text, Document } from "@react-pdf/renderer";
import Navigation from "./Navigation";
import Description from "./Description";
import Variables from "./Variables";
import PersonaDescription from "./PersonaDescription";
import Card from "./DemographicCard";

import { formatDate } from "../../../helpers/formatter";
import styles from "./styles";

export default function Report({ data }) {
  return (
    <Document
      title={`Report-${data.stats.name}-${formatDate(new Date())}`}
      author="By GowombatTeam for Global Data Resources"
      subject="Audience Report"
      keywords="Report, Audience, Stats, IDFree"
      creator="Generated by Global Data Resources application"
      producer="Global Data Resources, IDFree"
    >
      <Page style={styles.page}>
        <View style={styles.mainTitleContainer}>
          <Text style={styles.mainTitle}>
            Full Report for {data.stats.name}
          </Text>
        </View>
        <Navigation />
        <View style={styles.container}>
          <View style={styles.halfContainer}>
            <Description stats={data.stats} />
          </View>
          <View style={styles.halfContainer}>
            <Variables audienceVariables={data.stats.audienceVariables} />
          </View>
        </View>
      </Page>
      <Page style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.subTitle}>Who they are</Text>
          <View style={styles.personaContainer}>
            {data.personaDescription.map((persona, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <PersonaDescription persona={persona} key={`persona-${index}`} />
            ))}
          </View>
        </View>
        <View style={styles.section}>
          <Text style={styles.subTitle}>Description</Text>
          <Image style={styles.mapImage} source={{ uri: data.tagImage }} />
        </View>
      </Page>
      <Page style={styles.page}>
        <Navigation active="second" />
        <View>
          <Image
            style={styles.mapImage}
            source={{ uri: data.mapImage }}
          ></Image>
        </View>
      </Page>
      <Page style={styles.page}>
        <Navigation active="third" />
        <View style={styles.demographicList}>
          {data.demographics
            .sort((a, b) => a.order - b.order)
            .map(item => {
              return (
                <Card
                  data={item}
                  key={`demographics-card-${item.order}`}
                  index={`demographics - card - ${item.order}`}
                />
              );
            })}
        </View>
      </Page>
    </Document>
  );
}

Report.propTypes = {
  data: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})),
    personaDescription: PropTypes.arrayOf(PropTypes.shape({})),
    stats: PropTypes.shape({
      audienceVariables: PropTypes.arrayOf(
        PropTypes.arrayOf(PropTypes.shape({}))
      ),
      name: PropTypes.string
    }),
    mapData: PropTypes.arrayOf(PropTypes.string),
    demographics: PropTypes.arrayOf(PropTypes.shape({})),
    tagImage: PropTypes.string,
    mapImage: PropTypes.string
  }).isRequired
};
